export default {
    title: 'Micro-trends'
}
